import { useNavigate } from "react-router-dom";
import Loader from "../helpers/loader/loader";
import Back from "../helpers/back";
import { useInfinityScroll } from "./hooks/infinity-load";
import { useFilters } from "./hooks/use-filters";
import { useProducts } from "./hooks/use-products";
import { format } from "date-fns";

export const AdminOrders = () => {
  const nav = useNavigate();
  const { filtersComponent, filters, search, currentStep } = useFilters();
  const { orders, isLoading, setPage } = useProducts(filters, currentStep, search);

  const cursor = useInfinityScroll(() => {
    setPage((prev) => prev + 1);
  });

  if (isLoading && orders.length === 0) return <Loader />;
  return (
    <div className={`main_container`}>
      <Back />
      <div className={`container`}>
        {filtersComponent}
        <div className={`catalog_v2`} style={{ marginTop: "10px" }}>
          {orders && orders.length !== 0 ? (
            orders.map((i, index) => {
              return (
                <div
                  className="cart_v2"
                  onClick={() => {
                      return nav(`/result/${i.id}`)
                  }}
                  ref={(index === Number(orders.length) - 1) ? cursor : null}
                  key={i.id}
                >
                  <div className="text">
                    <div className="good_id">НОМЕР СДЕЛКИ: {i.id}</div>
                    <div className="title_v2">
                      {i.attributes.offer.data.attributes.name}
                    </div>
                    { i.attributes?.cashbackDate && <div className="price_v2">
                      Дата выплаты:{" "}
                      {format(new Date(i.attributes?.cashbackDate), "dd.MM.yyyy")}
                    </div> }
                    <div className="price_v2">
                      Цена для покупателя:{" "}
                      {i.attributes?.priceForUserOffer} руб
                    </div>
                    <div className="price_v2">
                      Сумма к оплате:{" "}
                      {i.attributes?.cashbackAmount} руб
                    </div>
                    <div className="price_v2">
                      Текущий шаг:{" "}
                      {i.attributes.step === 6
                        ? "Заказ оформлен"
                        : i.attributes.step === 7
                        ? "Товар получен"
                        : "Отзыв оставлен"}
                    </div>
                    <div className="price_v2">
                      Статус оплаты:{" "}
                      {i.attributes.status === null
                        ? "Не оплачено"
                        : i.attributes.status === "Оплачено"
                        ? "Оплачено"
                        : "Не оплачено"}
                    </div>
                  </div>
                  <svg
                    className="arrow_icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    stroke="#000000"
                    stroke-width="0.00024000000000000003"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      {" "}
                      <path
                        d="M9.71069 18.2929C10.1012 18.6834 10.7344 18.6834 11.1249 18.2929L16.0123 13.4006C16.7927 12.6195 16.7924 11.3537 16.0117 10.5729L11.1213 5.68254C10.7308 5.29202 10.0976 5.29202 9.70708 5.68254C9.31655 6.07307 9.31655 6.70623 9.70708 7.09676L13.8927 11.2824C14.2833 11.6729 14.2833 12.3061 13.8927 12.6966L9.71069 16.8787C9.32016 17.2692 9.32016 17.9023 9.71069 18.2929Z"
                        fill="#b8b8b8"
                      ></path>{" "}
                    </g>
                  </svg>
                </div>
              );
            })
          ) : (
            <div
              style={{ textAlign: "center", margin: "30px 0", width: "100%" }}
            >
              Сделки не найдены
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
